import { AppState } from '../model';
import { NotificationStore } from './notification.model';

export const getNotification = (state: AppState): NotificationStore => state.notification;

export const getMessage = (state: AppState): string => state.notification.message;

export const getParameter = (state: AppState): {} => state.notification.parameter;